import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import CategoriasList from "../../../components/CategoriasList";
import ProductosList from "../../../components/ProductosList";
import { MobileContext } from "../Mobile";

const drawerWidth = "100vw";

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#fafafa"
  },
  drawerContainer: {
    overflow: "auto"
  },
  backButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  container: {
    marginTop: theme.spacing(7)
  },
  primaryColor: {
    color: theme.palette.primary.main
  },
  paper: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  },
  itemText: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2)
  }
}));

const Catalogo = () => {
  const classes = useStyles();
  const { catalogoOpen, onCloseCatalogo } = useContext(MobileContext);
  const [openCategorias, setOpenCategorias] = useState(false);
  const [openProductos, setOpenProductos] = useState(false);

  return (
    <>
      <CategoriasList open={openCategorias} onClose={() => setOpenCategorias(false)} />
      <ProductosList open={openProductos} onClose={() => setOpenProductos(false)} />

      <Drawer
        className={classes.drawer}
        open={catalogoOpen}
        anchor="right"
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <AppBar position="sticky">
          <Toolbar>
            <IconButton
              className={classes.backButton}
              edge="start"
              color="inherit"
              onClick={onCloseCatalogo}
            >
              <ArrowBackIcon />
            </IconButton>

            <Typography className={classes.title} variant="h6">
              Catálogo
            </Typography>
          </Toolbar>
        </AppBar>

        <Container className={classes.container} maxWidth="sm">
          <List>
            <Paper className={classes.paper} elevation={3}>
              <ListItem button onClick={() => setOpenCategorias(true)}>
                <ListItemIcon>
                  <FontAwesomeIcon icon={faTags} size="3x" className={classes.primaryColor} />
                </ListItemIcon>
                <ListItemText
                  className={classes.itemText}
                  primary={<Typography variant="h6">Categorías</Typography>}
                />
                <ListItemSecondaryAction>
                  <ChevronRightIcon fontSize="large" color="primary" />
                </ListItemSecondaryAction>
              </ListItem>
            </Paper>

            <Paper className={classes.paper} elevation={3}>
              <ListItem button onClick={() => setOpenProductos(true)}>
                <ListItemIcon>
                  <FontAwesomeIcon
                    icon={faShoppingCart}
                    size="3x"
                    className={classes.primaryColor}
                  />
                </ListItemIcon>
                <ListItemText
                  className={classes.itemText}
                  primary={<Typography variant="h6">Productos</Typography>}
                />
                <ListItemSecondaryAction>
                  <ChevronRightIcon fontSize="large" color="primary" />
                </ListItemSecondaryAction>
              </ListItem>
            </Paper>
          </List>
        </Container>
      </Drawer>
    </>
  );
};

export default Catalogo;
